export const maxVendorLocationsCount = 20
export const maxCarrierLocationsCount = 50
export const maxEquipmentsCount = 100
export const maxContactsCount = 15
export const maxResalePriceOverwriteRuleCount = 20
